import { AxiosError } from 'axios'

import query from './APIServicesV2'

interface Media {
  params: {
    documentType: string
    size: number
    ext: string
    isPrivate: boolean
    name: string
  }
  file: File
}

export const postMedia = async (media: Media) => {
  const response = await query.post('/media', media.params)

  // Crear un AbortController para manejar timeout
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), 30000) // 30 segundos timeout

  try {
    const uploadResponse = await fetch(response.data.url, {
      method: 'PUT',
      body: media.file,
      headers: {
        'Content-type': media.file.type,
      },
      signal: controller.signal, // Agregar señal de abort
    })

    clearTimeout(timeoutId)

    // Verificar si la respuesta fue exitosa
    if (!uploadResponse.ok) {
      throw new Error(`Upload failed with status: ${uploadResponse.status}`)
    }

    return response.data.key
  } catch (error) {
    clearTimeout(timeoutId)

    // Si el error es por timeout/abort
    if ((error as Error & { name?: string }).name === 'AbortError') {
      throw new Error(
        'La subida de archivo tardó demasiado tiempo. Verifique su conexión e intente nuevamente.'
      )
    }

    // Si es un error de red
    if (
      error instanceof TypeError &&
      error.message.includes('Failed to fetch')
    ) {
      throw new Error(
        'Error de conexión. Verifique su conexión a internet e intente nuevamente.'
      )
    }

    throw error
  }
}

export const postMediaUrl = async (params: {
  key: string
  isPrivate: string
}) => {
  const response = await query.post('/media/url', params)

  return response?.data?.url
}

export const deleteMedia = async (key: string) => {
  try {
    // Intentar con el endpoint /media y parámetros requeridos
    const response = await query.deleteAPI('/media', {
      key,
      isPrivate: true, // Todos los archivos de documentos se crean como privados
    })
    return response.data
  } catch (error: unknown) {
    // Si falla, intentar con el endpoint /media/{key}
    if ((error as AxiosError)?.response?.status === 404) {
      try {
        const response = await query.deleteAPI(`/media/${key}`)
        return response.data
      } catch {
        throw error
      }
    }
    throw error
  }
}
